import { Options, Vue } from 'vue-class-component';
import { ApartmentDTO, ApartmentLabelDTO } from '../../../../../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'EntrancePlantApartment',
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: false,
    },
    callingCodeOrBrfa: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['apartment-selected'],
})
export default class EntrancePlantApartment extends Vue {
  apartment!: ApartmentDTO;
  callingCodeOrBrfa!: boolean;

  mounted(): void {}

  selected() {
    this.$emit('apartment-selected', this.apartment);
  }

  getLabelText(label: ApartmentLabelDTO) {
    if (this.callingCodeOrBrfa) {
      return label.callingCode;
    }

    if (label.isPrivate) {
      return `${label.surname} ${label.name}`;
    } else {
      return label.companyName;
    }
  }
}
